var _g, _text, _text2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKfhZaheb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 110,
    viewBox: "0 0 300 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "white"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0,55,55)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51 45 L51 16 Q51 8 44 11 L28 18 Q21 21 26 26 L44 44 Q51 51 51 45 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(45,55,55)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51 45 L51 16 Q51 8 44 11 L28 18 Q21 21 26 26 L44 44 Q51 51 51 45 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(90,55,55)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51 45 L51 16 Q51 8 44 11 L28 18 Q21 21 26 26 L44 44 Q51 51 51 45 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(135,55,55)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51 45 L51 16 Q51 8 44 11 L28 18 Q21 21 26 26 L44 44 Q51 51 51 45 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(180,55,55)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51 45 L51 16 Q51 8 44 11 L28 18 Q21 21 26 26 L44 44 Q51 51 51 45 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(225,55,55)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51 45 L51 16 Q51 8 44 11 L28 18 Q21 21 26 26 L44 44 Q51 51 51 45 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(270,55,55)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51 45 L51 16 Q51 8 44 11 L28 18 Q21 21 26 26 L44 44 Q51 51 51 45 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(315,55,55)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51 45 L51 16 Q51 8 44 11 L28 18 Q21 21 26 26 L44 44 Q51 51 51 45 Z"
  })))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 115,
    y: 60,
    fill: "white",
    fontFamily: "Montserrat, 'Segoe UI', Arial, sans-serif",
    fontWeight: 800,
    fontSize: 52,
    letterSpacing: 2
  }, "KFH")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 116,
    y: 96,
    fill: "white",
    fontFamily: "Montserrat, 'Segoe UI', Arial, sans-serif",
    fontWeight: 500,
    fontSize: 30,
    letterSpacing: 1
  }, "Zaheb")));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKfhZaheb);
export default __webpack_public_path__ + "static/media/kfh_zaheb.9905e5af.svg";
export { ForwardRef as ReactComponent };